import { ComponentProps, forwardRef } from 'react';
import { SxProps } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { StyledButton } from './Button.styles';

export type ButtonProps = ComponentProps<'button'> & {
  variant?:
    | 'primary'
    | 'secondary'
    | 'secondaryError'
    | 'link'
    | 'additionalLinkPrimary'
    | 'additionalLinkSecondary'
    | 'round';
  size?: 'extra' | 'small' | 'medium' | 'large';
  width?: 'extraSmall' | 'small' | 'medium' | 'fluid' | 'auto';
  fontSize?: string;
  endIcon?: React.ReactNode;
  children?: React.ReactNode;
  'data-testid'?: string;
  typographyStyle?: Variant;
  sx?: SxProps;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ endIcon, children, ...rest }, ref) => {
  return (
    <StyledButton hasIconOnly={!!endIcon && !children} {...rest} ref={ref}>
      {children}
      {endIcon}
    </StyledButton>
  );
});

Button.displayName = 'Button';
